var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m137.5 282.4c0-6.8 2.8-13.5 7.5-18.2 4.8-4.8 11.5-7.5 18.2-7.5 6.8 0 13.5 2.8 18.2 7.5 4.8 4.8 7.6 11.5 7.6 18.2 0 6.8-2.8 13.5-7.6 18.2-4.8 4.8-11.5 7.6-18.2 7.6-6.8 0-13.5-2.8-18.2-7.6-4.7-4.7-7.5-11.5-7.5-18.2zm73.6 84.6c0-9.6 4-19.2 10.8-26s16.4-10.8 26-10.8 19.2 4 26 10.8 10.8 16.4 10.8 26c0 9.7-4 19.2-10.8 26s-16.4 10.8-26 10.8-19.2-3.9-26-10.8c-6.8-6.8-10.8-16.4-10.8-26zm0-220.8c0-9.6 4-19.2 10.8-26s16.4-10.8 26-10.8 19.2 4 26 10.8 10.8 16.4 10.8 26-4 19.2-10.8 26-16.4 10.8-26 10.8-19.2-4-26-10.8-10.8-16.4-10.8-26zm-121.4-108.5c0-9.6 4-19.2 10.8-26s16.4-10.8 26-10.8 19.2 4 26 10.8 10.8 16.4 10.8 26-4 19.2-10.8 26-16.4 10.8-26 10.8-19.2-4-26-10.8c-6.9-6.8-10.8-16.4-10.8-26zm202.6 458.9h-185.4l-61-390.2-45.9 8.1 69.9 424.7h258.6l76.6-424.3-45.8-8.9z"}));
}

Trash.defaultProps = {"height":"540","viewBox":"0 0 406 540","width":"406"};

module.exports = Trash;

Trash.default = Trash;
